import React from "react";
import { Card } from "react-bootstrap";
import "../Blogs/Blogs.css";

const BlogsCard = ({ blog }) => {
  const { title, url, img } = blog;
  return (
    <div className="col-lg-4">
      <div className="card-section mt-4">
        <a className="blog-link" rel="noreferrer" target="_blank" href={url}>
          <Card className="blog-card" style={{ border: 0 }}>
            <Card.Img variant="top" src={img} />
            <Card.Body>
              <Card.Title>{title.substring(0, 65)}...</Card.Title>
            </Card.Body>
          </Card>
        </a>
      </div>
    </div>
  );
};

export default BlogsCard;
